// Quotation InternalReview Stage  Btn related codes goes here

// NPM Imports
import React, { Fragment } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Button } from "@revvsales/components";

// Components Imports
// import ReferralPopup from "../../SettingsWrapper/ReferralPopup";
// import ExportDocumentBtn from "../../QuotationTopbar/QuotationTopbarBtns/ExportDocumentBtn";
import SendForReview from "../../QuotationTopbar/QuotationTopbarBtns/SendForReview";
// import QuotationBottomStages from "../../QuotationTopbar/QuotationBottomBar/QuotationBottomStages";
// import { USER_ROLES } from "../../../constants/roleList";
// import { GlobalUtils } from "../../../utils";

// Declarations

// Destructuring
// const { readDataFromLocalStorage } = GlobalUtils;

export default function QuotationInternalReviewOwnerBtns(props) {
  // const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");

  // const [showReferralPopup, setShowReferralPopup] = useState(false);
  // let popupSpace = null;

  // const _toggleNavbarPopup = flag => {
  //   setShowReferralPopup(flag);
  // };

  // if (showReferralPopup) {
  //   popupSpace = <ReferralPopup closePopup={_toggleNavbarPopup} />;
  // }

  return (
    <Fragment>
      {/**
      {popupSpace}
      <Fragment>
        <div>
          <Tooltip placement="bottom" overlay="Refer and get benefits!">
            <span
              className="referral-wrapper"
              onClick={() => _toggleNavbarPopup("showReferralPopup", true)}
              onKeyPress={() => {}}
              tabIndex="0"
              role="button">
              <span aria-label="referral-gift-wrapper" role="img">
                🎁
              </span>
            </span>
          </Tooltip>
        </div>
        {CURRENT_USER.roles[0].name === USER_ROLES.ADMIN && (
          <div>
            <Tooltip placement="bottom" overlay="Invite team members to Revv">
              <span
                className="user-role-wrapper"
                onClick={() => props.togglePopUp("showTeammatePopup", true)}
                onKeyPress={() => {}}
                tabIndex="0"
                role="button">
                <FontAwesomeIcon icon={["fas", "user-plus"]} />
              </span>
            </Tooltip>
          </div>
        )}
        <div className="user-invite-line" />
      </Fragment>
      */}

      {/* <QuotationBottomStages {...props} /> */}
      {/**
       
      {!props.showForm ? (
        <Tooltip
          placement="bottom"
          align={{
            offset: [0, 4],
          }}
          overlay="Please get document approved to send it for eSign.">
          <div>
            <Button
              className="revv-btn-disabled-esign"
              id={"signerDetails".replace(/ +/g, "-").toLowerCase()}>
              <FontAwesomeIcon
                icon={["far", "signature"]}
                className="documentrecipientlist-role-icon"
              />
              &nbsp; eSign
            </Button>
          </div>
        </Tooltip>
      ) : null}
      */}
      {/* <Button
        className="approve-document"
        onClick={() => props.togglePopUp("Approve", true)}
        id={"Approve".replace(/ +/g, "-").toLowerCase()}
        data-test="quotationTopbar-upgrade-stage-btn">
        Approve
      </Button>
      <Button
        className="reject-document"
        onClick={() => props.togglePopUp("Reject", true)}
        id={"Reject".replace(/ +/g, "-").toLowerCase()}
        data-test="quotationTopbar-upgrade-stage-btn">
        Reject
      </Button> */}
      <SendForReview {...props} />
      {/* <Button
        className="analyse-document"
        onClick={() =>
          props.togglePopUp("showAddRecipientsPopup", true, "forReviewer")
        }
        id={"Send for review".replace(/ +/g, "-").toLowerCase()}
        data-test="quotationTopbar-upgrade-stage-btn">
        Send for review
      </Button> */}
      {/* <ExportDocumentBtn docStatus={props.docStatus} />
      <Button
        className="analyse-document"
        onClick={() => props.togglePopUp("showConfirmMoveToDraftPopup", true)}
        id={"EditBtnWithRbac".replace(/ +/g, "-").toLowerCase()}
        data-test="quotationTopbar-upgrade-stage-btn">
        Edit document
      </Button> */}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/QuotationInternalReviewOwnerBtns.js